/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import { forwardRef } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @param {*} props
 */
const FormCheckboxNoLabel = forwardRef(function (props, ref) {
    return (
        <div
            className={classNames({
                'motili-checkbox': true,
                'motili-checkbox-noLabel': props.header,
            })}
            style={props.style}
        >
            <input
                type='checkbox'
                id={props.controlId}
                name={props.name}
                checked={props.uncontrolled ? undefined : props.checked}
                onClick={props.onClick}
                onChange={props.onChange}
                disabled={props.disabled}
                ref={ref}
            />
            <label htmlFor={props.controlId} />
        </div>
    );
});
export default FormCheckboxNoLabel;

FormCheckboxNoLabel.propTypes = {
    controlId: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    uncontrolled: PropTypes.bool,
    style: PropTypes.object,
    header: PropTypes.bool,
};

FormCheckboxNoLabel.defaultProps = {
    controlId: 'form-checkbox',
    uncontrolled: false,
    checked: false,
    header: false,
    style: { width: '100%' },
};
